import {Stroke, Style } from "ol/style";

export const inventoryTrackedRouteStyle = (feature, overflow = null) => {
    return [
        new Style({
            stroke: new Stroke({
                color: 'rgba(194,11,11,0.2)',
                width: 5,
            }),
        }),
        new Style({
            stroke: new Stroke({
                color: 'rgba(238,71,71, 0.85)',
                width: 1,
            }),
        })
    ];
}

export const farInventoryTrackedRouteStyle = () => {
    return new Style()
}